













































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ScoreBlockCard from "../ScoreBlockCard.vue";
import BarthelIndexInput from "../BarthelIndexInput.vue";
import {
  KOGNITIF_FIELDS,
  NUTRISI_FIELDS,
  RISIKO_JATUH_FIELDS
} from "@/constants/geriatriOptions";
import { AsesmenGeriatriContent, BarthelSumber } from "@/types/asesmen_geriatri";
import {
  barthelColor,
  barthelKategori,
  barthelTotal,
  kognitifColor,
  kognitifKategori,
  kognitifTotal,
  nutrisiColor,
  nutrisiInterpretasi,
  nutrisiTotal,
  risikoJatuhColor,
  risikoJatuhKategori,
  risikoJatuhLengkap,
  risikoJatuhMobilitasSkor,
  risikoJatuhTotal
} from "@/utils/geriatriScore";

@Component({ components: { ScoreBlockCard, BarthelIndexInput } })
export default class SectionSkriningSindrom extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: AsesmenGeriatriContent["skrining"];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "idle" }) readonly sourceState!: string;
  @Prop({ type: Boolean, default: true }) readonly barthelAwalOtomatis!: boolean;

  kognitifFields = KOGNITIF_FIELDS;
  nutrisiFields = NUTRISI_FIELDS;
  risikoJatuhFields = RISIKO_JATUH_FIELDS;

  get sumberBarthel(): BarthelSumber | null {
    const sumber = this.value.status_fungsional.barthel_awal.sumber;
    return sumber && sumber.asesmen_awal_ranap_keperawatan_id ? sumber : null;
  }

  get kognitifTotal(): number {
    return kognitifTotal(this.value.kognitif);
  }
  get kognitifKategori(): string {
    return kognitifKategori(this.kognitifTotal);
  }
  get kognitifColor(): string {
    return kognitifColor(this.kognitifTotal);
  }

  get barthelAwalTotal(): number {
    return barthelTotal(this.value.status_fungsional.barthel_awal);
  }
  get barthelAwalKategori(): string {
    return barthelKategori(this.barthelAwalTotal);
  }
  get barthelAwalColor(): string {
    return barthelColor(this.barthelAwalTotal);
  }

  get nutrisiTotal(): number {
    return nutrisiTotal(this.value.nutrisi);
  }
  get nutrisiInterpretasi(): string {
    return nutrisiInterpretasi(this.nutrisiTotal);
  }
  get nutrisiColor(): string {
    return nutrisiColor(this.nutrisiTotal);
  }

  get risikoJatuhTotal(): number {
    return risikoJatuhTotal(this.value.risiko_jatuh);
  }
  get risikoJatuhMobilitasSkor(): number {
    return risikoJatuhMobilitasSkor(this.value.risiko_jatuh);
  }
  get risikoJatuhLengkap(): boolean {
    return risikoJatuhLengkap(this.value.risiko_jatuh);
  }
  get risikoJatuhKategori(): string {
    return risikoJatuhKategori(this.value.risiko_jatuh);
  }
  get risikoJatuhColor(): string {
    return risikoJatuhColor(this.value.risiko_jatuh);
  }

  jepitSkor(key: string, max: number) {
    const nilai = (this.value.kognitif as any)[key];
    if (nilai === null || nilai === "") return;
    if (nilai < 0) this.$set(this.value.kognitif, key, 0);
    if (nilai > max) this.$set(this.value.kognitif, key, max);
  }
}
